import React from "react";
import {
  facebookIcon,
  facebookIcon2,
  heroBgVideo,
  instagramIcon,
  instagramIcon2,
  newHeroImage2,
  twitterIcon,
  twitterIcon2,
} from "../assets";
import AboutHero from "./AboutHero";
import SocialHero from "./SocialHero";

const NewHeroSection = () => {
  const styles = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${newHeroImage2})`,
    // backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.6)), url(${sliderImages[current].imageUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
  };

  return (
    <div>
      <div className="relative h-[100vh] w-full rounded-b-3xl md:px-[100px] mb-16 bg-[#FFFBF2]">
        <div className="h-screen text-white flex flex-col justify-center md:pl-[60px] pl-4 md:pt-10 absolute z-40">
          <p className="font-bold mb-4 text-[#00A859]">WELCOME TO</p>
          <h1 className="font-trajan md:text-6xl text-4xl md:leading-snug leading-snug font-bold ">
            <span className="text-transparent stroke-yellow stroke-2 font-light text-[#FF9900]">
              The Imperial By
            </span>{" "}
            <br /> WosAm APARTMENTS
          </h1>
        </div>
        <div className="h-screen inset-0 bg-[#00000090] absolute md:left-[100px] md:right-[100px]"></div>
        <video className="h-full object-cover" autoPlay muted loop>
          <source src={heroBgVideo} type="video/mp4" />
        </video>
        <SocialHero />
        <div className="bg-[#FF9700] h-screen absolute right-0 w-[100px] top-0 md:block hidden"></div>
      </div>
    </div>
  );
};

export default NewHeroSection;
